<template>
  <CompanyAttorneyForm ref="companyAttorneyForm" title="Редактировать доверенность" @submit="onSubmit"
                       @cancel="onCancel"/>
</template>
<script>
import CompanyAttorneyForm from "./CompanyAttorneyForm";
import AttorneyService from "@/services/attorney.service";
import _ from 'underscore';
import moment from 'moment';

export default {
  name: 'EditCompanyAttorneyForm',
  data() {
    return {
      attorney: [],
      attorneyItems: []
    }
  },
  components: {
    CompanyAttorneyForm
  },
  methods: {
    onSubmit() {
      let vm = this;
      let formData = vm.$refs.companyAttorneyForm.getFormData();
      AttorneyService.editAttorney(
          {
            Id: vm.attorney.id,
            Number: formData.number,
            Start: moment(formData.startDate, 'YYYY-MM-DD'),
            End: moment(formData.endDate, 'YYYY-MM-DD'),

            Position: formData.position,
            Fullname: formData.fullName,
            PersonInn: formData.personInn,

            PassportSerial: formData.passportSerial,
            PassportNumber: formData.passportNumber,
            PassportIssuer: formData.passportIssuer,
            PassportIssuedOn: moment(formData.passportIssuedOn, 'YYYY-MM-DD'),

            ContractorInn: formData.contractorInn,
            ContractorName: formData.contractorName,
            ContractNumber: formData.contractNumber,
            ContractDate: formData.contractDate ? moment(formData.contractDate, 'YYYY-MM-DD') : null,

            Items: formData.items
          }
      ).then(function () {
        vm.$refs.companyAttorneyForm.hideLoading();
      });
    },
    loadAttorneyItems(id) {
      let vm = this;
      return new Promise((resolve, reject) => {
        AttorneyService.getCompanyAttorney(id).then(function (response) {
          vm.attorneyItems = _.map(response.data.Items, function (item) {
            return {
              id: item.Id,
              measurement: item.Measurement,
              product: item.Product,
              quantity: item.Quantity,
            }
          });
          resolve();
        }).catch(function () {
          reject();
        }).finally(function () {
          resolve();
        })
      });

    },
    onCancel() {
      this.$emit("cancel");
    },
    clear() {
      this.$refs.companyAttorneyForm.clear();
    },
    setAttorney(attorney, attorneyItems) {
      let vm = this;
      vm.attorney = attorney;
      vm.loadAttorneyItems(attorney.id).then(function () {
        vm.$nextTick(function () {
          vm.$refs.companyAttorneyForm.setAttorney(attorney, this.attorneyItems);
        });
      });
    }
  }
}
</script>